
/**
 * This functions executes an ajax call
 * to wordpress and returns an ajax response.
 * 
 * @param {*} params Parameters to be included in the ajax call 
 * @returns json OBJ
 */
async function ajaxRequest(params){

  // Packing data 
  const data = new FormData();
  for ( let key in params ) {
    data.append(key, params[key]);
  }
  
  const url = window.finderWPData.ajaxurl
  let result;
  try {
    // Post request
    const response = await fetch(url, {
      method: "POST",
      body: data
    });

    // Coverting response to ajax.
    result = await response.json();
  } catch (error) {
    console.log('Fetch error: ', error);
  }

  return result;

}

/**
 * Updating Sports dropdown styles
 * 
 * @param {event} e OnChange trigger event  
 */
export function updateDropdownStyles(e){
  e.preventDefault();
  const target = e.target;
  const dropdownColor = "#191818"
  const labelId = "activity-title";
   
  // Update Select label with the selected
  // sport
  if (target.dataset){
    const label = document.getElementById(labelId);
    label.innerHTML = target.dataset.title;
    label.style.color = dropdownColor;
  }
}

/**
 * Sets the sports data on the
 * Activity finder
 * 
 * @param {function} callback  Callback to be triggered after the sport data has been set.
 */
export default function setSport(e, callback){

  const target = e.target;

  if (target && window.finderWPData){


    // Handling async data call
    ( async () => {

      // Execute ajax call and waiting for the 
      // data.
      const result = await ajaxRequest({
        action: window.finderWPData.task,
        nonce: window.finderWPData.nonce,
        sport_slug: target.dataset.id
      });

      // Set the new data in

      if (result && result.data){
        window.newData = result;

        // Execute callback function 
        callback();
      }

      // Error while fetching the data
      if (result && result.error){
        console.log('Fetch error: ',result.error);
      }
      
    })();
    
  }

}
